import { useEffect, useRef, useState } from 'react';

import VisibleLoading from '@/components/utilities/VisibleLoading';
import TextBlocks from '@/components/utilities/TextBlocks';

const QuestionsBlock = ({ title, questions }) => {
  return (
    <div className="mx-auto my-30 w-[90vw] xl:w-(--container-width)">
      {title && <div className="txt-md mb-8 font-semibold tracking-wide uppercase">{title}</div>}

      {(questions || []).map((question) => (
        <Question key={question.id} {...question} />
      ))}
    </div>
  );
};
export default QuestionsBlock;

const Question = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const inputRef = useRef();

  const onToggle = () => {
    setIsOpen((v) => !v);
  };

  useEffect(() => {
    if (isOpen) {
      setHeight(inputRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen]);

  return (
    <VisibleLoading delay={300}>
      {({ ref, className }) => (
        <div ref={ref} className={`my-4 border-b border-gray-200 py-4 ${className || ''}`.trim()}>
          <div className="flex cursor-pointer items-center justify-between" onClick={onToggle}>
            <h4>{question}</h4>

            <svg
              className={`${isOpen ? 'rotate-180' : ''}`}
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M9.88 11.0596L16 17.1662L22.12 11.0596L24 12.9396L16 20.9396L8 12.9396L9.88 11.0596Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            className={`overflow-hidden transition-all duration-300 ease-in-out`}
            ref={inputRef}
            style={{ maxHeight: height }}
          >
            <div className="pt-5 pb-2 font-normal lg:text-xl">
              <TextBlocks template={answer} />
            </div>
          </div>
        </div>
      )}
    </VisibleLoading>
  );
};
